import React from "react";

import { useSelector } from "../../utils/hooks";

import "./ConfigService.scss";

const ConfigServices = () => {
	const configServices = useSelector(
		(state) => state.popup.products.mainProduct.configServices,
	);

	if (!configServices || configServices.length === 0) {
		return null;
	}

	return (
		<section className="addtocart-configServices__container">
			{configServices?.map((service: any) => {
				const serviceId = service.id;

				const selectedOption =
					service.options.find((o) => o.selected);

				const selectedService = service.selected && service;

				return (
					<div key={serviceId} className="addtocart-configServices">
						<div className="addtocart-configServices__info">
							<h2>{service.displayName}</h2>

							<div
								className="addtocart-insurance__info--description"
								dangerouslySetInnerHTML={{
									__html: selectedOption?.name || selectedService?.description,
								}}
							/>
						</div>
						<div className="addtocart-configServices__price">
							<strong>{selectedOption?.price || selectedService?.price}</strong>
						</div>
					</div>
				);
			})}
		</section>
	);
};

export default ConfigServices;
